import _ from 'lodash';
import moment from 'moment';
import { BaseModel } from '../lib';
import _renameKeys from '../../lib/snowjs/lodash-mixins/rename-keys';


export default class ScheduleModel extends BaseModel {


  invalidate() {
    this.invalidateMinMaxDates();
  }

  invalidateMinMaxDates() {
    // invalidate the min/max dates

    let minDate = null;
    let maxDate = null;

    let _evalDate = (date) => {
      if (date && date.isValid()) {
        if (!minDate || date.isBefore(minDate)) {
          minDate = date;
        }
        if (!maxDate || date.isAfter(maxDate)) {
          maxDate = date;
        }
      }
    };

    _evalDate(this.daterangeStartMomentValue);
    _evalDate(this.daterangeEndMomentValue);

    _.each(this.showtimes, showtime => {
      let startDate = moment(showtime.startDate);
      let endDate = moment(showtime.endDate);
      _evalDate(startDate);
      _evalDate(endDate);
      _.each(showtime.showtimeExceptions, exception => {
        _evalDate(moment(exception.date));
      });
    });

    this.minDateMomentValue = minDate;
    this.maxDateMomentValue = maxDate;
  }

  get daterangeStartMomentValue() {
    return this._convertToMomentValue(this.daterange_start);
  }
  set daterangeStartMomentValue(value) {
    this.daterange_start = this._convertToDateString(value);
    this.invalidateMinMaxDates();
  }

  get daterangeEndMomentValue() {
    return this._convertToMomentValue(this.daterange_end);
  }
  set daterangeEndMomentValue(value) {
    this.daterange_end = this._convertToDateString(value);
    this.invalidateMinMaxDates();
  }

  get minDateMomentValue() {
    return this._convertToMomentValue(this.min_date);
  }
  set minDateMomentValue(value) {
    this.min_date = this._convertToDateString(value);
  }

  get maxDateMomentValue() {
    return this._convertToMomentValue(this.max_date);
  }
  set maxDateMomentValue(value) {
    this.max_date = this._convertToDateString(value);
  }

  toPublishedData() {
    let intKeys = 'id'.split(' ');
    let obj = _.toPlainObject(this);
    _.each(intKeys, k => {
      _.set(obj, k, _.parseInt(_.get(obj, k)));
    });
    obj.showtimes = _.map(obj.showtimes, showtime => {
      showtime.showtimeExceptions = _.map(showtime.showtimeExceptions, v => {
        v.date = this._convertToDateString(this._convertToMomentValue(v.date), 'YYYY-MM-DD');
        return v;
      });
      return  showtime;
    });
    delete obj.manager_notes;
    _renameKeys(obj, { comments: 'comment', closed_for_season: 'closedForSeason' });

    return obj;
  }
}
